// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sb0OjrEEtXw0YCts7ry7[data-has-many='true'] {
  font-size: var(--campaign-prize-fund-currency-has-many);
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
  .XH3ObqptTsufG1cadz71[data-has-many='true'] {
    font-size: var(--campaign-prize-fund-font-has-many-mobile);
  }
  .Sb0OjrEEtXw0YCts7ry7[data-has-many='true'] {
    height: 100%;
    font-size: var(--campaign-prize-fund-currency-has-many-mobile);
  }
  .Sb0OjrEEtXw0YCts7ry7[data-has-many='true'][data-variant='prize-pool'] {
    height: auto;
  }
}
@media (max-width: 1024px),(min-width: 768px) and (max-width: 1024px) and (orientation: landscape),(orientation: portrait) {
@media (max-color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  /* .currency is a direct child of .prizeContainer (see PrizeFundCampaign.tsx), which itself
     carries these attributes — group under it. */
  .XH3ObqptTsufG1cadz71[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) {
    font-size: var(--campaign-prize-fund-font-has-many-multi-portrait);
  }
  .XH3ObqptTsufG1cadz71[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) .Sb0OjrEEtXw0YCts7ry7 {
    font-size: var(--campaign-prize-fund-currency-has-many-multi);
  }
}
}
@media not all and (orientation: portrait) {
@media not all and ( (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)) {
@media not all and (max-width: 1024px) {
@media (color:2147477350) and (orientation: portrait) and (max-width: 767px) {
  /* .currency is a direct child of .prizeContainer (see PrizeFundCampaign.tsx), which itself
     carries these attributes — group under it. */
  .XH3ObqptTsufG1cadz71[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) {
    font-size: var(--campaign-prize-fund-font-has-many-multi-portrait);
  }
  .XH3ObqptTsufG1cadz71[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) .Sb0OjrEEtXw0YCts7ry7 {
    font-size: var(--campaign-prize-fund-currency-has-many-multi);
  }
}
}
}
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/shared/PrizeFundCampaign/css/hasManyStyles.module.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;AACzD;AACA;EACE;IACE,0DAA0D;EAC5D;EACA;IACE,YAAY;IACZ,8DAA8D;EAChE;EACA;IACE,YAAY;EACd;AACF;AACA;AAAA;EACE;iDAC+C;EAC/C;IACE,kEAAkE;EACpE;EACA;IACE,6DAA6D;EAC/D;AACF;AAAA;AATA;AAAA;AAAA;AAAA;EACE;iDAC+C;EAC/C;IACE,kEAAkE;EACpE;EACA;IACE,6DAA6D;EAC/D;AACF;AAAA;AAAA;AAAA","sourcesContent":[".currency[data-has-many='true'] {\n  font-size: var(--campaign-prize-fund-currency-has-many);\n}\n@media (--campaign-mobile) {\n  .prizeContainer[data-has-many='true'] {\n    font-size: var(--campaign-prize-fund-font-has-many-mobile);\n  }\n  .currency[data-has-many='true'] {\n    height: 100%;\n    font-size: var(--campaign-prize-fund-currency-has-many-mobile);\n  }\n  .currency[data-has-many='true'][data-variant='prize-pool'] {\n    height: auto;\n  }\n}\n@media (--campaign-mobile) and (orientation: portrait) and (--campaign-tablet-portrait-rule) {\n  /* .currency is a direct child of .prizeContainer (see PrizeFundCampaign.tsx), which itself\n     carries these attributes — group under it. */\n  .prizeContainer[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) {\n    font-size: var(--campaign-prize-fund-font-has-many-multi-portrait);\n  }\n  .prizeContainer[data-has-many='true'][data-view='multi'][data-variant='card']:not([data-collapsed='true']) .currency {\n    font-size: var(--campaign-prize-fund-currency-has-many-multi);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currency": `Sb0OjrEEtXw0YCts7ry7`,
	"prizeContainer": `XH3ObqptTsufG1cadz71`
};
export default ___CSS_LOADER_EXPORT___;
